module.exports = __webpack_public_path__ + "static/media/heart.7e60714c.svg";